// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: #508bfc;
    margin: 0;
}


.dashboard-title {
    font-weight: bold;
    margin-bottom: 2rem;
    text-align: center;
    margin-top: 100px;
}

.oxy-video-container {
    position: relative;
    /*height: 100vh;*/
    overflow: hidden;
}

.background-video {
    position: fixed;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    transform: translate(-50%, -50%);
    z-index: -1;
}

.oxy-video-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.53);
    z-index: 0;
}

.login-content {
    position: relative;
    z-index: 1;
    color: white;
}

.dashboard-title {
    margin-top: 100px;
    font-weight: bold;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
}

.login-card {
    background: rgba(255, 255, 255, 0.85);
    border-radius: 1rem;
    max-width: 500px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,SAAS;AACb;;;AAGA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":["body {\n    background-color: #508bfc;\n    margin: 0;\n}\n\n\n.dashboard-title {\n    font-weight: bold;\n    margin-bottom: 2rem;\n    text-align: center;\n    margin-top: 100px;\n}\n\n.oxy-video-container {\n    position: relative;\n    /*height: 100vh;*/\n    overflow: hidden;\n}\n\n.background-video {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    min-width: 100%;\n    min-height: 100%;\n    width: auto;\n    height: auto;\n    transform: translate(-50%, -50%);\n    z-index: -1;\n}\n\n.oxy-video-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.53);\n    z-index: 0;\n}\n\n.login-content {\n    position: relative;\n    z-index: 1;\n    color: white;\n}\n\n.dashboard-title {\n    margin-top: 100px;\n    font-weight: bold;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);\n}\n\n.login-card {\n    background: rgba(255, 255, 255, 0.85);\n    border-radius: 1rem;\n    max-width: 500px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
